export * from "./equirectangularCapture.pure";

import "../Shaders/equirectangularPanorama.fragment";
